import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/General/ImageLink/imageLink"
    ).then((module) => ({ default: module.ImageLink }))
);
